import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import "./UserSelect.css"
import React, {useEffect, useState} from "react";
import RootState from "../../../redux/states/root.state";
import { fetchUsers } from "../../../redux/actions/users.actions";
import { CircularProgress, Pagination, Button, TextField, Checkbox, FormControlLabel, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Box, Typography } from "@mui/material";
import { fetchUserGroupUsersByEmail } from "../../../redux/actions/userGroups.actions";

interface UserSelectProps {
    checked:any[];
    setChecked: any;
    user_group_id?:any;
}

const MultiSelect: React.FC<UserSelectProps> = ({
    checked,
    setChecked,
    user_group_id,
}) => {
const dispatch: AppDispatch = useDispatch();
const {data:users,meta,loading} = useSelector((state: RootState) => state.users);

const [pageNumber, setPageNumber] = useState(1);
const [email, setEmail] = useState(``);
const [emailQuery, setEmailQuery] = useState<any>(null);

const handleCheck = (user:any) => {
    let newArr = [...checked];
    let found = checked?.find((checked_user:any)=>user?.id===checked_user?.id)!==undefined;
    if(found){
      newArr = newArr.filter((checked_user:any)=>checked_user?.id!==user?.id);
    } else {
      newArr.push(user);
    }
    setChecked(newArr);
}

useEffect(() => {
    let query = `page=${pageNumber}`;


    if (emailQuery){
        query = query + `&email=${emailQuery}`
    }

    if (user_group_id){
        dispatch(fetchUserGroupUsersByEmail({id:user_group_id, params:query}));
    } else {
        dispatch(fetchUsers(query));
    }
  }, [dispatch,pageNumber, emailQuery]);

  return (
    <>
    <div className="user-search-container">
        <TextField type="search" placeholder="Search email..." onChange={(e)=>setEmail(e.target.value)} size="small" fullWidth/>
        <Button type="button" variant="contained" onClick={()=>setEmailQuery(email)} size="small">Search</Button>
    </div>

    {loading ?
        <div className="no-users"><CircularProgress size={"24px"}/></div>
        :
    users.length>0 ? 
        <div className="select-container">
            <List 
                dense
                sx={{
                    maxHeight: 200,
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(0,0,0,0.1)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.5)',
                        },
                    },
                }}
            >
                {users.map((user: any) => (
                    <ListItem key={user.id} disablePadding>
                        <ListItemButton
                            onClick={() => handleCheck(user)}
                            selected={checked.some(c => c.id === user.id)}
                            sx={{ borderRadius: 1 }}
                        >
                            <ListItemIcon>
                                <Checkbox 
                                    checked={checked.some(c => c.id === user.id)}
                                    size="small"
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body2">
                                        {user?.name !== '' ? `${user?.name} (${user?.email})` : user?.email}
                                    </Typography>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            {meta?.last_page>1 && <Pagination 
                count={meta?.last_page} 
                size="small"
                onChange={(e,page)=>setPageNumber(page)}
                page={pageNumber}
                showLastButton 
                showFirstButton 
                disabled={meta?.last_page===1}
            />}
        </div>
        :
        <div>No Users Found.</div>
    }
    </>
  );
};

export default MultiSelect;
